import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "ariaLabel", "ariaLabelledby", "ariaDescribedby", "ariaDescription", "dataTestId", "ariaLive", "ariaAtomic", "xstyle"];
import { c as _c } from "react-compiler-runtime";
import { forwardRef } from 'react';
import { SpinnerRoot } from './primitives';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Config-layer wrapper for `Spinner`. Removes the low-level `xstyle` override
 * surface and exposes only the curated props needed for everyday loading indicators.
 *
 * This component is part of Trellis's config API layer and covers the majority
 * of use cases. For advanced patterns, use the compositive API directly. If you
 * find yourself doing so, share your use case in #trellis-support — it directly
 * informs how we evolve the config layer.
 *
 * @see {@link SpinnerRoot | Spinner}
 */
export const Spinner = /*#__PURE__*/forwardRef((t0, ref) => {
  var _id, _ariaLabel, _ariaLabelledby, _ariaDescribedby, _ariaDescription, _dataTestId;
  const $ = _c(21);
  let ariaAtomic;
  let ariaDescribedby;
  let ariaDescription;
  let ariaLabel;
  let ariaLabelledby;
  let ariaLive;
  let dataTestId;
  let id;
  let restProps;
  if ($[0] !== t0) {
    const {
        id: t1,
        ariaLabel: t2,
        ariaLabelledby: t3,
        ariaDescribedby: t4,
        ariaDescription: t5,
        dataTestId: t6,
        ariaLive: t7,
        ariaAtomic: t8
      } = t0,
      t9 = _objectWithoutPropertiesLoose(t0, _excluded);
    id = t1;
    ariaLabel = t2;
    ariaLabelledby = t3;
    ariaDescribedby = t4;
    ariaDescription = t5;
    dataTestId = t6;
    ariaLive = t7;
    ariaAtomic = t8;
    restProps = t9;
    $[0] = t0;
    $[1] = ariaAtomic;
    $[2] = ariaDescribedby;
    $[3] = ariaDescription;
    $[4] = ariaLabel;
    $[5] = ariaLabelledby;
    $[6] = ariaLive;
    $[7] = dataTestId;
    $[8] = id;
    $[9] = restProps;
  } else {
    ariaAtomic = $[1];
    ariaDescribedby = $[2];
    ariaDescription = $[3];
    ariaLabel = $[4];
    ariaLabelledby = $[5];
    ariaLive = $[6];
    dataTestId = $[7];
    id = $[8];
    restProps = $[9];
  }
  const t1 = (_id = id) === null || _id === void 0 ? void 0 : _id.root;
  const t2 = (_ariaLabel = ariaLabel) === null || _ariaLabel === void 0 ? void 0 : _ariaLabel.root;
  const t3 = (_ariaLabelledby = ariaLabelledby) === null || _ariaLabelledby === void 0 ? void 0 : _ariaLabelledby.root;
  const t4 = (_ariaDescribedby = ariaDescribedby) === null || _ariaDescribedby === void 0 ? void 0 : _ariaDescribedby.root;
  const t5 = (_ariaDescription = ariaDescription) === null || _ariaDescription === void 0 ? void 0 : _ariaDescription.root;
  const t6 = (_dataTestId = dataTestId) === null || _dataTestId === void 0 ? void 0 : _dataTestId.root;
  let t7;
  if ($[10] !== ariaAtomic || $[11] !== ariaLive || $[12] !== ref || $[13] !== restProps || $[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = /*#__PURE__*/_jsx(SpinnerRoot, Object.assign({}, restProps, {
      ref: ref,
      id: t1,
      "aria-label": t2,
      "aria-labelledby": t3,
      "aria-describedby": t4,
      "aria-description": t5,
      "data-test-id": t6,
      "aria-live": ariaLive,
      "aria-atomic": ariaAtomic
    }));
    $[10] = ariaAtomic;
    $[11] = ariaLive;
    $[12] = ref;
    $[13] = restProps;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
});
Spinner.displayName = 'Spinner';